import React from "react";
import { ArrowRight, CreditCard } from "lucide-react";

export default function TrialCapture() {
    return (
        <div
            data-testid="trial-capture"
            className="border-b border-bg/20 bg-ink text-bg"
        >
            <div className="mx-auto max-w-[1440px] px-6 md:px-12 lg:px-16 py-10 md:py-12">
                <div className="grid lg:grid-cols-12 gap-8 items-center">
                    <div className="lg:col-span-8 flex items-start gap-5">
                        <div className="hidden md:flex h-12 w-12 border border-bg/40 items-center justify-center shrink-0">
                            <CreditCard
                                size={20}
                                strokeWidth={2.25}
                                className="text-forge"
                            />
                        </div>
                        <div>
                            <span
                                className="font-mono uppercase tracking-[0.2em] text-[11px]"
                                style={{ color: "hsl(var(--ink-mute))" }}
                            >
                                Free Month · Card required
                            </span>
                            <h3 className="font-display text-2xl md:text-3xl lg:text-4xl font-bold tracking-tight mt-2 leading-tight text-bg">
                                Start with 30 days of full ReachForge access.
                            </h3>
                            <p className="text-bg/70 mt-3 max-w-2xl text-sm md:text-base">
                                £0 today. Stripe collects payment details
                                upfront, creates your licence after checkout,
                                then moves the subscription to Launch Monthly
                                unless cancelled before the trial ends.
                            </p>
                        </div>
                    </div>

                    <div className="lg:col-span-4 flex flex-col sm:flex-row lg:flex-col gap-3">
                        <a
                            data-testid="trial-submit"
                            href="/checkout?plan=free_month"
                            className="h-12 sm:h-14 px-6 bg-forge text-bg border border-forge font-semibold text-sm inline-flex items-center justify-center gap-2 hover:bg-forge-hover hover:border-forge-hover transition-colors"
                        >
                            Start Free Month <ArrowRight size={14} />
                        </a>
                        <p className="font-mono uppercase tracking-[0.2em] text-[10px] text-bg/50 m-0 lg:text-right">
                            1 computer total · One trial per email or company
                        </p>
                    </div>
                </div>
            </div>
        </div>
    );
}
